<template>
  <div class="question-list p-4">
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Caricamento...</span>
      </div>
      <div class="loading-text">Caricamento in corso...</div>
    </div>

    <!--<div v-if="isCountdownLoading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status"></div>
      <div class="loading-text">Caricamento countdown...</div>
    </div>

    <BreadcrumbElement :items="[{ title: 'Dashboard', view: 'DashboardView' }]" :currentPage="'Elenco Quesiti'"
      @change-view="$emit('change-view', $event.view, $event.elementId)" />-->

    <ToastDialog :title="toastTitle" :message="toastMessage" :error="toastError" />

    <!--<h5 class="mb-4">Tutti i quesiti ({{ pagination.total }})</h5>
    <button class="btn btn-outline-secondary btn-sm" @click="showFilters = !showFilters">
      <i class="bi bi-funnel-fill"></i>
    </button>-->

    <div class="card mb-3 shadow-sm">
      <div class="card-body d-flex align-items-center justify-content-between">



        <div class="d-flex align-items-center">
          <h5 v-if="!showCountdownView" class="mb-0 me-2">
            Tutti i quesiti ({{ pagination.total || 0 }})
          </h5>

          <h5 v-if="showCountdownView" class="mb-0 me-2">
            Tutti i quesiti ({{ countdownQuestions.length || 0 }})
          </h5>

          <button v-if="!showCountdownView" class="btn btn-outline-secondary btn-sm p-1"
            style="border-color: #D3D3D3; font-size: 0.8rem;" @click="showFilters = !showFilters">
            <i class="bi bi-funnel-fill"></i>
          </button>
        </div>

        <!--<div v-if="!showCountdownView">
        <button class="btn btn-outline-secondary me-2" @click="toggleCountdownView">
          <i class="bi bi-clock"></i> Visualizzazione Countdown
        </button>
      </div>

      <div v-if="showCountdownView">
        <button class="btn btn-outline-secondary me-2" @click="toggleCountdownView">
          <i class="bi bi-table"></i> Visualizzazione Tabella
        </button>
      </div>-->
      </div>
    </div>

    <transition name="slide-fade" @enter="enter" @leave="leave">
      <CommonFilters :key="filtersKey" v-show="showFilters" :allTopics="allTopics" :allLegislations="allLegislations"
        :allExperts="allExperts" :allArticles="allArticles" :allRegions="allRegions" :allYears="allYears"
        v-model:selectedTopics="selectedTopics" v-model:selectedLegislation="selectedLegislation"
        v-model:selectedArticles="selectedArticles" :initFilterExpert="filterExpert" :initFilterState="filterState"
        :initFilterRegion="filterRegion" :initFilterYear="filterYear" :initFilterId="filterId"
        :initFilterObject="filterObject" :initFilterOrganization="filterOrganization" :initFilterText="filterText"
        :initCreatedFrom="filterCreatedFrom" :initCreatedTo="filterCreatedTo" :initExpiresFrom="filterExpiresFrom"
        :initExpiresTo="filterExpiresTo" :isGestore="isGestore || isLegalExpert" :canManageRoles="canManageRoles"
        @update:selectedLegislation="onLegislationChange" @update:selectedTopics="val => selectedTopics = val"
        @update:selectedArticles="val => selectedArticles = val" @filter="applyFilter"
        :disableSearch="myQuestionsActive" />
    </transition>


    <div v-if="!showCountdownView" class="mb-3 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <label class="me-2 mb-0">Elementi per pagina:</label>
        <select class="form-select w-auto" v-model.number="pagination.perPage" @change="loadQuestions(1)">
          <option v-for="n in [10, 25, 50, 100, 500]" :key="n" :value="n">{{ n }}</option>
        </select>
        <!-- Checkbox subito a destra, senza margini -->
        <div class="form-check" style="margin-left:20px;">
          <input class="form-check-input" type="checkbox" id="myQuestionsCheck" v-model="myQuestionsActive"
            @change="toggleMyQuestions" />
          <label class="form-check-label mb-0" for="myQuestionsCheck">
            I miei quesiti
          </label>
        </div>
      </div>


      <button v-if="!showCountdownView" class="btn btn-outline-secondary me-2" @click="downloadPdf"
        :disabled="isDownloading || selectedQuestions.length === 0" >
        <span v-if="!isDownloading">
          <i class="bi bi-file-earmark-pdf me-1"></i> Scarica PDF
        </span>
        <span v-else>
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Generazione in corso...
        </span>
      </button>
    </div>

    <template v-if="!showCountdownView && (isGestore || isLegalExpert)">
      <GestoreTable :questions="questions" :pagination="pagination" :sort-field="sortField"
        :can-assign="canAssignQuestion" :sort-direction="sortDirection" :state-icons="stateIcons"
        :selected-experts="selectedExperts" @page-change="loadQuestions" @sort="handleSort"
        @open-detail="navigateToQuestionDetail" @change-view="changeView" :experts="allExperts"
        :allExpertsNotForReply="allExpertsNotForReply" @update:selected-questions="selectedQuestions = $event"
        :current-filters="{
          id: filterId,
          object: filterObject,
          organization: filterOrganization,
          text: filterText,
          region: filterRegion,
          year: filterYear,
          expert_id: filterExpert,
          state: filterState,
          created_from: filterCreatedFrom,
          created_to: filterCreatedTo,
          expires_from: filterExpiresFrom,
          expires_to: filterExpiresTo
        }" />
    </template>

    <!--<template v-else>
      <div class="countdown-view">
        <div class="countdown-column" v-for="(group, index) in countdownGroups" :key="index">
          <h6>{{ group.title }} ({{ group.questions.length }})</h6>

          <div class="questions-wrapper" :style="getWrapperStyle(group.questions.length)">
            <div v-for="q in group.questions" :key="q.id" class="question-card"
              @click="openQuestionDetailCountDown(q.id)">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <strong class="me-2">{{ q.object }}</strong>

                <div class="avatar-circle" :class="{ 'empty': !q.initials || q.initials === '--' }">
                  {{ q.initials || '-' }}
                </div>
              </div>

              <div class="text-muted small mb-1">
                #{{ q.id }} – {{ q.organization }}
              </div>

              <div class="text-muted small d-flex align-items-center mb-2">
                <i class="bi bi-clock me-1"></i> {{ formatDate(q.created_at) }}
              </div>

              <div>
                <span class="status-box" :class="'status-' + q.state.color">
                  {{ q.state.label }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>-->

    <!--<template v-else>
      <AppaltanteTable :questions="questions" :pagination="pagination" :sort-field="sortField"
        :sort-direction="sortDirection" :state-icons="stateIcons" @page-change="loadQuestions" @sort="handleSort"
        @open-detail="openQuestionDetail" />
    </template>-->

    <ModalView v-model="showDetailModal" :title="`Dettaglio Quesito #${selectedQuestion.id || ''}`" icon="search">
      <QuestionForm v-model="selectedQuestion" :readonly="true" />
    </ModalView>
  </div>
</template>

<script>
import ToastDialog from '../../../components/common/ToastDialog.vue';
import BreadcrumbElement from '../../../components/common/BreadcrumbElement.vue';
import CommonFilters from './partials/CommonFilters.vue';
import AppaltanteTable from './partials/AppaltanteTable.vue';
import GestoreTable from './partials/GestoreTable.vue';
import toastable from '../../../mixins/toastable';
import ModalView from '../../../components/common/ModalView.vue';
import QuestionForm from './partials/QuestionForm.vue';
import ElencoDownloadView from '../../../components/views/ElencoDownloadView.vue'
import { ResolvedPos } from '@tiptap/pm/model';
import navigationHistory from '../../../services/navigationHistory';


export default {
  name: 'QuestionsView',
  components: {
    ToastDialog,
    BreadcrumbElement,
    CommonFilters,
    AppaltanteTable,
    GestoreTable,
    ModalView,
    QuestionForm,
    ElencoDownloadView

  },
  mixins: [toastable],
  data() {
    return {
      selectedQuestion: {
        object: '',
        text: '',
        topics: []
      },
      selectedQuestions: [],
      showDetailModal: false,
      isGestore: false,
      isLegalExpert: false,
      questions: [],
      pagination: { currentPage: 1, perPage: 10, total: 0, lastPage: 1 },
      sortField: 'created_at',
      sortDirection: 'desc',
      allTopics: [],
      allLegislations: [],
      allArticles: [],
      allExperts: [],
      allExpertsNotForReply: [],
      selectedTopics: [],
      selectedLegislation: null,
      selectedArticles: [],
      toastTitle: '',
      toastMessage: '',
      toastError: false,
      stateIcons: {
        INVIATO: { icon: 'bi-plus-circle', activeColor: '#0d6efd', inactiveColor: 'gray', label: 'Nuovo' },
        ASSEGNATO: { icon: 'bi-person-check', activeColor: '#20c997', inactiveColor: 'gray', label: 'Assegnato' },
        RISPOSTA_IN_BOZZA: { icon: 'bi-pencil-square', activeColor: '#0dcaf0', inactiveColor: 'gray', label: 'Risposta in bozza' },
        EVASO: { icon: 'bi-check-circle', activeColor: '#198754', inactiveColor: 'gray', label: 'Evaso' },
        IN_SALA_ATTESA: { icon: 'bi-hourglass', activeColor: '#ffc107', inactiveColor: 'gray', label: 'In sala d’attesa' },
        IN_ESAMINA_UOC: { icon: 'bi-search', activeColor: '#6610f2', inactiveColor: 'gray', label: 'Assegnato a UOC' },
        NON_ASSEVERATO: { icon: 'bi-shield-exclamation', activeColor: '#fd7e14', inactiveColor: 'gray', label: 'Non asseverato' },
        ASSEVERATO: { icon: 'bi-shield-check', activeColor: '#0dcaf0', inactiveColor: 'gray', label: 'Asseverato' },
        NON_PUBBLICATO: { icon: 'bi-eye-slash', activeColor: '#dc3545', inactiveColor: 'gray', label: 'Non pubblicato' },
        PUBBLICATO: { icon: 'bi-eye', activeColor: '#0d6efd', inactiveColor: 'gray', label: 'Pubblicato' },
        STORICO: { icon: 'bi-archive', activeColor: '#000000', inactiveColor: 'gray', label: 'Storico' },
      },
      filterId: '',
      filterObject: '',
      filterOrganization: '',
      filterText: '',
      filterRegion: [],
      filterYear: [],
      filterExpert: [],
      filterState: [],
      allYears: [],
      isLoading: true,
      isDownloading: false,
      showFilters: false,
      showCountdownView: false,
      isCountdownLoading: false,
      countdownQuestions: [],
      filterCreatedFrom: '',
      filterCreatedTo: '',
      filterExpiresFrom: '',
      filterExpiresTo: '',
      allSearchIds: [],
      selectedExperts: {},
      myQuestionsActive: false,
      filtersKey: 0,
    };
  },
  computed: {
    canAssignQuestion() {
      return this.$root.user.permissions?.includes('assign-question');
    },
    canAssignOne() {
      return this.$root.user?.permissions?.includes('assign-one-question');
    },
    canManageRoles() {
      return this.$root.user.permissions?.includes('manage-roles');
    },
    countdownGroups() {
      if (this.isCountdownLoading) return [];

      const now = new Date();
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(now.getMonth() - 1);

      const twentyNineDaysAgo = new Date();
      twentyNineDaysAgo.setDate(now.getDate() - 29);

      const twentyEightDaysAgo = new Date();
      twentyEightDaysAgo.setDate(now.getDate() - 28);

      const sortDesc = (arr) => arr.slice().sort((a, b) => new Date(b.created_at) - new Date(a.created_at));


      return [
        {
          title: 'DA ASSEGNARE',
          questions: sortDesc(this.countdownQuestions.filter(q => q.state_id === 'INVIATO'))
        },
        {
          title: 'ASSEGNATO',
          questions: sortDesc(this.countdownQuestions.filter(q => q.state_id === 'ASSEGNATO'))
        },
        {
          title: 'IN LAVORAZIONE',
          questions: sortDesc(this.countdownQuestions.filter(q => q.state_id === 'IN_LAVORAZIONE'))
          /**
           * title: '28 giorni fa',
           * 
           * questions: this.countdownQuestions.filter(q => {
            const created = new Date(q.created_at);
            return created.toDateString() === twentyNineDaysAgo.toDateString() && q.state_id === 'INVIATO'; 
          })*/
        },
        {
          title: 'ALTRO',
          questions: this.countdownQuestions.filter(q => {
            const created = new Date(q.created_at);
            return created.toDateString() === twentyEightDaysAgo.toDateString() && q.state_id === 'ASSEGNATO';
          })
        }
      ];
    }
  }
  ,
  methods: {
    restoreState(state) {
      if (!state) return;

      // Ripristina i filtri principali
      this.myQuestionsActive = state.myQuestionsActive || false;
      this.selectedTopics = state.selectedTopics || [];
      this.selectedArticles = state.selectedArticles || [];
      this.selectedLegislation = state.selectedLegislation || null;
      this.showFilters = state.showFilters || false;

      // Ripristina la paginazione
      if (state.pagination) {
        this.pagination.currentPage = state.pagination.currentPage;
        this.pagination.perPage = state.pagination.perPage;
      }

      // Ripristina l'ordinamento
      this.sortField = state.sortField || 'created_at';
      this.sortDirection = state.sortDirection || 'desc';

      // Ripristina i filtri di ricerca
      this.filterId = state.filterId || '';
      this.filterObject = state.filterObject || '';
      this.filterOrganization = state.filterOrganization || '';
      this.filterText = state.filterText || '';
      this.filterRegion = state.filterRegion || [];
      this.filterYear = state.filterYear || [];
      this.filterExpert = state.filterExpert || [];
      this.filterState = state.filterState || [];
      this.filterCreatedFrom = state.filterCreatedFrom || '';
      this.filterCreatedTo = state.filterCreatedTo || '';
      this.filterExpiresFrom = state.filterExpiresFrom || '';
      this.filterExpiresTo = state.filterExpiresTo || '';

      this.filtersKey++;


      // Ricarica i dati con i filtri ripristinati
      this.$nextTick(() => {
        this.loadQuestions(this.pagination.currentPage);
      });
    },
    navigateToQuestionDetail(questionId) {
      // Salva lo stato corrente prima di navigare
      const currentState = {
        selectedExperts: this.selectedExperts,
        selectedTopics: this.selectedTopics,
        myQuestionsActive: this.myQuestionsActive,
        selectedTopics: this.selectedTopics,
        selectedArticles: this.selectedArticles,
        selectedLegislation: this.selectedLegislation,
        showFilters: this.showFilters,
        pagination: {
          currentPage: this.pagination.currentPage,
          perPage: this.pagination.perPage
        },
        sortField: this.sortField,
        sortDirection: this.sortDirection,
        filterId: this.filterId,
        filterObject: this.filterObject,
        filterOrganization: this.filterOrganization,
        filterText: this.filterText,
        filterRegion: this.filterRegion,
        filterYear: this.filterYear,
        filterExpert: this.filterExpert,
        filterState: this.filterState,
        filterCreatedFrom: this.filterCreatedFrom,
        filterCreatedTo: this.filterCreatedTo,
        filterExpiresFrom: this.filterExpiresFrom,
        filterExpiresTo: this.filterExpiresTo
      };

      navigationHistory.push('QuestionsView', null, currentState);
      this.$emit('change-view', 'QuestionDetailExpertView', questionId);
    },
    toggleMyQuestions() {
      if (this.myQuestionsActive) {
        this.showFilters = false;

        this.filterExpert = [this.$root.user.id];

        this.filterState = ['IN_LAVORAZIONE', 'ASSEGNATO'];
      } else {
        this.filterExpert = [];
        this.filterState = [];
      }

      // Ricarica i quesiti
      this.loadQuestions(1);
    },
    getCurrentFilters() {
      return {
        id: this.filterId,
        object: this.filterObject,
        organization: this.filterOrganization,
        text: this.filterText,
        region: this.filterRegion,
        year: this.filterYear,
        expert_id: this.filterExpert,
        state: this.filterState,
        created_from: this.filterCreatedFrom,
        created_to: this.filterCreatedTo,
        expires_from: this.filterExpiresFrom,
        expires_to: this.filterExpiresTo
      };
    },
    formatDate(isoDate) {
      if (!isoDate) return '';
      const date = new Date(isoDate);

      return date.toLocaleString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    changeView(viewName, id) {
      console.log('Evento ricevuto:', viewName, id);
      this.$emit('change-view', viewName, id);
    },
    getWrapperStyle(count) {
      //if (count > 4) {
      const cardHeightPx = 142;
      const gapPx = 8;
      const remBase = 16;

      const maxHeightRem = (cardHeightPx * 4 + gapPx * 3) / remBase;

      return {
        maxHeight: `${maxHeightRem}rem`,
        overflowY: 'auto'
      };
      //}
      //return {};
    },
    openQuestionDetailCountDown(id) {
      //this.$router.push({ name: 'QuestionDetailView', params: { id } });
      this.changeView('QuestionDetailExpertView', id)
    },
    formatState(state) {
      const map = {
        INVIATO: { label: "RICEVUTO", color: "yellow" },
        ASSEGNATO: { label: "ASSEGNATO", color: "blue" },
        IN_LAVORAZIONE: { label: "IN LAVORAZIONE", color: "purple" },
      };
      return map[state] || { label: state, color: "gray" };
    },
    toggleCountdownView() {
      this.showCountdownView = !this.showCountdownView;
      if (this.showCountdownView) {
        this.showFilters = false;
      }
    },

    openQuestionDetail(item) {
      this.selectedQuestion = JSON.parse(JSON.stringify(item));
      this.showDetailModal = true;
    },
    async loadCountdownQuestions() {
      this.isCountdownLoading = true;

      try {
        const response = await this.$root.$api.get('/questions/countdown');

        this.countdownQuestions = response.data.data.map(q => {
          const newQ = { ...q };

          //const expert = q.assignments?.legalExpert;
          const expert = q.initials;
          if (expert) {
            //const first = expert.first_name?.charAt(0).toUpperCase() || "";
            //const last = expert.last_name?.charAt(0).toUpperCase() || "";
            newQ.initials = q.initials;
          } else {
            newQ.initials = "-";
          }

          newQ.organization = q.organization || q.organization?.description || "—";

          const d = new Date(q.created_at);
          newQ.created_at = d.toISOString();

          // stato
          newQ.state = this.formatState(q.state_id);

          return newQ;
        });

      } finally {
        this.isCountdownLoading = false;
      }
    },
    async loadQuestions(page = 1) {
      this.isLoading = true;
      this.selectedQuestions = [];
      const defaultStates = ['IN_LAVORAZIONE', 'ASSEGNATO', 'EVASO', 'IN_ESAMINA_UOC', 'ASSEVERATO', 'NON_ASSEVERATO', 'PUBBLICATO'];
      if (this.canManageRoles) defaultStates.push('STORICO');

      const statesToInclude = (Array.isArray(this.filterState) && this.filterState.length)
        ? this.filterState.filter(s => s !== 'INVIATO')
        : defaultStates;

      try {
        const params = {
          page: page,
          per_page: this.pagination.perPage,
          sortField: this.sortField,
          sortDirection: this.sortDirection,
          topics: this.selectedTopics.join(','),
          articles: this.selectedArticles.join(','),
          legislation_id_v: this.selectedLegislation ?? '',
          id: this.filterId || '',
          object: this.filterObject || '',
          organization_desc: this.filterOrganization || '',
          text: this.filterText || '',
          region: this.filterRegion.join(',') || '',
          year: this.filterYear.join(',') || '',
          expert_id: Array.isArray(this.filterExpert) ? this.filterExpert.join(',') : '',
          //state: Array.isArray(this.filterState) ? this.filterState.join(',') : '',
          state: statesToInclude.join(','),
          created_from: this.filterCreatedFrom || '',
          created_to: this.filterCreatedTo || '',
          expires_from: this.filterExpiresFrom || '',
          expires_to: this.filterExpiresTo || ''
        };
        const response = await this.$root.$api.get('/questions', { params });
        const questionsWithArticleTitles = response.data.data.map(q => {
          const newQ = { ...q };

          const articlesArray = this.$root.contents?.articles || [];

          newQ.articles = (q.articles || []).map(a => {
            const content = articlesArray.find(c => c.id === a.id);
            if (!content || !content.versions || !content.versions.length) return { ...a, title: null };

            const lastVersion = content.versions.reduce(
              (prev, curr) => (curr.id > prev.id ? curr : prev),
              content.versions[0]
            );

            return { ...a, title: lastVersion.title };
          });

          return newQ;
        });
        this.questions = questionsWithArticleTitles;

        this.questions.forEach(q => {
          this.selectedExperts[q.id] = q.expert ? q.expert.id : '';
        });

        //this.questions = response.data.data;
        this.pagination = {
          currentPage: response.data.current_page,
          perPage: response.data.per_page,
          total: response.data.total,
          lastPage: response.data.last_page
        };
        this.allSearchIds = response.data.allSearchIds || [];
      } catch (error) {
        this.showErrorToast('Errore', 'Errore nel caricamento dei quesiti');
      } finally {
        this.isLoading = false;
      }
    },
    async loadExperts() {
      const response = await this.$root.$api.get('/users/legal');
      this.allExperts = response.data;
    },
    async loadExpertsNotForReply() {
      if (!this.canAssignOne) return;
      const response = await this.$root.$api.get('/users/legal-not-for-reply');
      this.allExpertsNotForReply = response.data;
    },
    async loadAllTopics() {
      const response = await this.$root.$api.get('/questions/topics');
      this.allTopics = response.data;
    },
    async loadAllLegislations() {
      const legislations = Object.values(this.$root.dlgs || {});

      const activeLegislation = legislations.filter(l => l.end === null);

      this.allLegislations = [
        {
          id: 0,
          begin: null,
          end: null,
          legislation: null,
          published_at: null,
          deleted_at: null,
          created_at: null,
          updated_at: null,
          title: "D.lgs 50/2016"
        },
        ...activeLegislation
      ];
    },
    async loadAllRegions() {
      const response = await this.$root.$api.get('/questions/regions');
      this.allRegions = response.data;
    },
    async loadAvailableYears() {
      const response = await this.$root.$api.get('/questions/years');
      this.allYears = response.data;
      if (this.allYears.length > 0 && this.filterYear.length === 0) {
        this.filterYear = [Math.max(...this.allYears)];
      }
    },
    handleSort({ field, direction }) {
      this.sortField = field;
      this.sortDirection = direction;
      this.loadQuestions(1);
    },
    applyFilter(filters) {
      this.filterId = filters.id || '';
      this.filterObject = filters.object || '';
      this.filterOrganization = filters.organization || '';
      this.filterText = filters.text || '';
      this.filterRegion = filters.region || [];
      this.filterYear = filters.year || [];
      this.filterExpert = filters.expert_id || [];
      this.filterState = filters.state || [];
      this.filterCreatedFrom = filters.created_from || '';
      this.filterCreatedTo = filters.created_to || '';
      this.filterExpiresFrom = filters.expires_from || '';
      this.filterExpiresTo = filters.expires_to || '';



      this.loadQuestions(1);
      //this.loadQuestions(filters);
    },
    async onLegislationChange(newLegId) {
      this.selectedLegislation = newLegId;
      this.selectedArticles = [];
      if (!newLegId) {
        this.allArticles = [];
        return;
      }

      const allArticles = Object.values(this.$root.contents?.articles || [])
        .filter(a => !a.deleted_at && a.versions && a.versions.length > 0);

      const legislation = this.allLegislations.find(l => l.id === newLegId);

      if (!legislation) {
        this.allArticles = [];
        return;
      }

      this.allArticles = this.filterArticlesByLegislationDate(allArticles, legislation);

      this.allArticles.sort((a, b) => a.id - b.id);

      this.allArticles = this.allArticles.map(a => ({
        ...a,
        title: a.versions[a.versions.length - 1]?.title || ''
      }));

    },
    async downloadPdf() {
      this.isDownloading = true;
      try {


        const idsToPrint = this.selectedQuestions.length > 0
          ? this.selectedQuestions
          //: this.questions.map(q => q.id);
          : this.allSearchIds;

        console.log(idsToPrint);

        const params = {
          ids: idsToPrint.join(','),
          sortField: this.sortField,
          sortDirection: this.sortDirection,
          topics: this.selectedTopics.join(','),
          articles: this.selectedArticles.join(','),
          legislation_id_v: this.selectedLegislation || '',
          id: this.filterId || '',
          object: this.filterObject || '',
          organization_desc: this.filterOrganization || '',
          text: this.filterText || '',
          region: this.filterRegion.join(',') || '',
          year: this.filterYear.join(',') || '',
          expert_id: Array.isArray(this.filterExpert) ? this.filterExpert.join(',') : '',
          state: Array.isArray(this.filterState) ? this.filterState.join(',') : '',
          created_from: this.filterCreatedFrom || '',
          created_to: this.filterCreatedTo || '',
          expires_from: this.filterExpiresFrom || '',
          expires_to: this.filterExpiresTo || ''
        };

        if (this.selectedQuestions.length > 0) {
          params.ids = this.selectedQuestions.join(',');
        }

        if (idsToPrint.length <= 20) {

          const response = await this.$root.$api.get('/questions/pdf/export', {
            params,
            responseType: 'blob'
          });
          /***/
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'quesiti_dettaglio.pdf');
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          await this.$root.$api.get('/questions/pdf/export', { params });
          this.showSuccessToast('PDF in preparazione. Ti verrà notificato quando sarà pronto.');
          this.$root.triggerPdfPolling();
        }
        /***/
        /*window.open(`/api/questions/pdf/export?${params.toString()}`, '_blank');*/
      } catch (error) {
        const status = error?.response?.status;
        const backendMessage = error?.response?.data?.message;

        if (status === 429) {
          this.showErrorToast('Limite stampe', backendMessage || 'Hai raggiunto il limite di stampe in coda.');
          return;
        }

        this.showErrorToast('Errore', backendMessage || 'Impossibile scaricare il PDF');
      } finally {
        this.isDownloading = false;
      }
    },
    filterArticlesByLegislationDate(allArticles, legislation, searchDate = null) {
      const activeDate = searchDate ? new Date(searchDate) : new Date();

      return allArticles
        .map(article => {
          const allVersions = article.versions.map(v => ({ ...v.version, frontendVersionId: v.id }));
          let activeVersions = allVersions.filter(v => {
            const begin = new Date(v.begin);
            const end = v.end ? new Date(v.end) : null;
            if (end) return activeDate >= begin && activeDate <= end;
            return activeDate >= begin;
          });
          if (activeVersions.length === 0 && allVersions.length > 0) {
            const sortedByBeginDesc = allVersions.sort((a, b) => new Date(b.begin) - new Date(a.begin));
            activeVersions = [sortedByBeginDesc[0]];
          }
          let filteredVersions = activeVersions;
          if (activeVersions.length > 1) {
            const mainVersion = activeVersions.find(v => {
              const begin = new Date(v.begin);
              const end = v.end ? new Date(v.end) : null;
              return (!end && begin <= activeDate) || (end && begin <= activeDate && end >= activeDate);
            }) || activeVersions[0];
            filteredVersions = activeVersions.filter(v => v.title === mainVersion.title);
          }
          const finalVersions = article.versions.filter(av =>
            filteredVersions.some(fv => fv.id === av.version.id)
          );
          return { ...article, versions: finalVersions };
        })
        .filter(article => article.versions.length > 0)
        .sort((a, b) => a.id - b.id);
    }
  },
  async mounted() {
    const roles = this.$root?.user?.roles || [];
    // Controlla se c'è uno stato da ripristinare
    let shouldRestoreState = false;
    let stateToRestore = null;

    if (navigationHistory.hasHistory()) {
      const lastEntry = navigationHistory.peek();
      if (lastEntry && lastEntry.viewName === 'QuestionsView' && lastEntry.state) {
        shouldRestoreState = true;
        stateToRestore = lastEntry.state;
        // Rimuovi l'entry dallo stack
        navigationHistory.pop();
      }
    }
    //this.isGestore = roles.some(role => role.id === 2);
    //this.isLegalExpert = roles.some(role => role.id === 3);
    this.isGestore = this.$root?.user?.permissions.includes('assign-question');
    this.isLegalExpert = this.$root?.user?.permissions.includes('view-questions') && this.$root?.user?.permissions.includes('view-question');
    await this.loadExperts();
    await this.loadExpertsNotForReply();
    await this.loadAvailableYears();
    await this.loadAllRegions();
    await this.loadAllTopics();
    await this.loadAllLegislations();
    if (shouldRestoreState && stateToRestore) {
      this.restoreState(stateToRestore);
    } else {
      // Altrimenti carica normalmente
      await this.loadQuestions();
    }
    //await this.loadCountdownQuestions();
  }
  ,
  async created() {
    console.log("caricamento articoli");
    if (!this.$root.contents) {
      await this.$root.fetchContents()
    }
  }
};
</script>
<style scoped>
.question-list {
  padding: 2rem;
}

/* Tabella base */
.table th,
.table td {
  vertical-align: middle;
}

.question-list table {
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  table-layout: fixed;
  width: 100%;
}

.question-list table thead {
  background-color: #0d6efd !important;
  color: white !important;
}

.question-list ::v-deep(table thead th) {
  text-align: center !important;
  vertical-align: middle !important;
}

/* Hover */
.question-list table tbody tr:hover {
  background-color: #f1f5fb;
  transition: background-color 0.2s ease;
}

/* Celle */
.question-list ::v-deep(.table-card table th),
.question-list ::v-deep(.table-card table td) {
  text-align: center;
  padding: 0.75rem 1rem;
}

/* Colonne specifiche 
.question-list ::v-deep(.table-card table th:nth-child(1)) {
  width: 5%;
}
.question-list ::v-deep(.table-card table th:nth-child(2)) {
  width: 10%;
}
.question-list ::v-deep(.table-card table th:nth-child(3)) {
  width: 25%;
}
.question-list ::v-deep(.table-card table th:nth-child(4)) {
  width: 40%;
  text-align: left;
}
.question-list ::v-deep(.table-card table th:nth-child(5)) {
  width: 15%;
}
.question-list ::v-deep(.table-card table th:nth-child(6)) {
  width: 5%;
}
  */

/* Celle centrali truncate */
.question-list ::v-deep(.table-card table td:nth-child(3)) {
  width: 15%;
  max-width: 15%;
  overflow: hidden;
}

.question-list ::v-deep(.table-card table td:nth-child(4)) {
  text-align: left;
}

.question-list ::v-deep(.table-card table td:nth-child(3) .text-truncate-ellipsis) {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.loading-text {
  margin-top: 1rem;
  font-weight: bold;
  color: #0d6efd;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.15em;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.1s ease;
  overflow: hidden;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  max-height: 500px;
  opacity: 0;
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  max-height: 500px;
  opacity: 1;
}

.countdown-view {
  flex: 1;
  display: flex;
  gap: 1rem;
  /*background: #f5f5f5;*/
  padding: 1rem;
  height: 75vh;
  /* prendi tutta l’altezza del contenitore genitore */
}

/** .countdown-column {
  flex: 1;
  background: #f8f9fa;
  border-radius: 0.25rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.questions-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
*/

.countdown-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  background: #f8f9fa;
  border-radius: 0.25rem;
  height: 100%;
}

.questions-wrapper {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.countdown-column h6 {
  text-align: center;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.question-card {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
}

.question-card:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.avatar-circle {
  width: 33.06px !important;
  height: 33px !important;
  flex: 0 0 auto;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: #6c757d;
  background: white;
  border: 2px solid gray;
}

.avatar-circle.empty {
  background: #fff;
  border-color: #6c757d;
  color: #6c757d;
}

.status-box {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.75rem;
  color: white;
  font-weight: 600;
}

.status-yellow {
  background: #ffc107;
}

.status-blue {
  background: #0d6efd;
}

.status-purple {
  background: #6f42c1;
}

.status-gray {
  background: #6c757d;
}
</style>